import { Button, Form, Input, Modal } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { AddDomain, UpdateDomain, axiosErrorMessages } from "../../../../API/api";
import axios, { AxiosError } from "axios";
interface AddEditDomainType {
    isAdd:boolean;
    editData:any
    handleClose: (data: boolean) => void;
  

  }
    const AddNewDomain: React.FC<AddEditDomainType> = ({ isAdd,editData,handleClose }) => {

    const [isOpen,setIsOpen] = useState<boolean>(true)
    const handleCloseAddEditPopup = () => {setIsOpen(false);handleClose(true)}
    const onSaveStatusHandler = (rowData:any) => {
if(rowData.domainName.trim()) {
  if(isAdd) {
    AddDomain(rowData.domainName.trim())
    .then((response:any)  =>{
      enqueueSnackbar("Added Successfully",{ variant: 'success', anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },})
      setIsOpen(false)
      handleClose(true)

    }).catch((error:any)  =>  {
      if(error.response.data.errors.Domain[0])
      enqueueSnackbar(error.response.data.errors.Domain[0],{ variant: 'error', anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },})
      else  {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    
    })

  }else{
    UpdateDomain(editData.domainId,rowData.domainName.trim())
    .then((response:any)  =>{
      enqueueSnackbar("Updated Successfully",{ variant: 'success', anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },})
      setIsOpen(false)
      handleClose(true)

    }).catch((error:any)  =>  {
      if(error.response.data.errors.Domain[0])
      enqueueSnackbar(error.response.data.errors.Domain[0],{ variant: 'error', anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },})
      else  {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
     
    })
  }
}else

        enqueueSnackbar('Enter Values', {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
     


    }
    const [addnewSoftwareForm] = Form.useForm();
    type FieldType = {
        domainName?: string;
         
        };
        useEffect(()=>{
            if(!isAdd)  {
                addnewSoftwareForm.setFieldsValue({
                    domainName:editData.domain
                })
            }
        },[])
    return <> 
    <div>
<Modal
              footer={null}
              title="Add/Edit Domain"
              open={isOpen}
              onCancel={handleCloseAddEditPopup}
              maskClosable={false}
            >
                   <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onSaveStatusHandler}
        autoComplete="off"
        form={addnewSoftwareForm}

      >
    
        <Form.Item<FieldType>
          label="Name"
          name="domainName"
          rules={[{ required: true, message: "Enter Name" }]}
        >
          <Input maxLength={50} />
        </Form.Item>
    
     
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button className="pm-btn" type="primary" htmlType="submit">
          Save
        </Button>
        </Form.Item>
      </Form>
            </Modal>


        </div>
    </>
}

export default AddNewDomain;